import { useState, useContext } from 'react';
import { Box, Typography, Button, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { OrdersContext } from '../../../lib/contexts/OrdersContext';
export default function CancelOrderPopUp({ open, orderID, onClose }) {
  const {
    actions: { deleteThisOrder },
  } = useContext(OrdersContext);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCancelOrder = async () => {
    setIsDeleting(true);
    try {
      const result = await deleteThisOrder(orderID);
      if (result) {
        onClose();
      } else {
        console.error('Failed to delete order');
      }
    } catch (error) {
      console.error('Error deleting order:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Box
        id="cancel-order-pop-up-container"
        sx={{
          display: 'flex',
          width: '377px',
          padding: '24px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '24px',
          borderRadius: '10px',
          border: '1px solid var(--color6, #D6D2E7)',
          background: 'var(--color2, #FBFBFC)',
        }}
      >
        <Box
          id="cancel-order-text"
          sx={{
            display: 'flex',
            paddingBottom: 'var(--2, 7px)',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--2-5, 10px)',
            alignSelf: 'stretch',
          }}
        >
          <Box
            id="cancel-order-header-container"
            sx={{
              display: 'flex',
              paddingTop: 'var(--1-5, 4px)',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: 'var(--0, 0px)',
              alignSelf: 'stretch',
            }}
          >
            <Box
              id="cancel-order-header"
              sx={{
                display: 'flex',
                padding: '7px 0px',
                alignItems: 'center',
                gap: '10px',
                alignSelf: 'stretch',
              }}
            >
              <Typography
                sx={{
                  flex: '1 0 0',
                  color: 'var(--color12, #1C124D)',
                  fontFamily: 'Montserrat',
                  fontSize: '24px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: '125%',
                }}
              >
                Are you sure you want to cancel?
              </Typography>
              <Button
                sx={{
                  display: 'flex',
                  width: 'var(--2, 28px)',
                  height: 'var(--2, 28px)',
                  padding: 'var(0px 0px) var(--2, 7px)',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '(--2, 7px)',
                  position: 'absolute',
                  right: '4px',
                  top: '4px',
                  borderRadius: '999px',
                  background: 'var(--color4, #EBE8F3)',
                }}
                onClick={onClose}
              >
                <CloseIcon
                  sx={{
                    width: 'var(--_16, 16px)',
                    height: 'var(--_16, 16px)',
                    flexShrink: '0',
                  }}
                />
              </Button>
            </Box>
          </Box>
          <Box
            id="cancel-order-body-container"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '24px',
              alignSelf: 'stretch',
            }}
          >
            <Typography
              sx={{
                alignSelf: 'stretch',
                color: 'var(--color12, #1C124D)',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 'normal',
              }}
            >
              You will not receive this order if you cancel it. You will have up until your original cutoff date to undo
              this cancel.
            </Typography>
          </Box>
        </Box>
        <Box
          id="cancel-order-buttons"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            gap: '13px',
            alignSelf: 'stretch',
          }}
        >
          <Button
            sx={{
              display: 'flex',
              height: '36px',
              padding: '0px 13px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '13px',
              alignSelf: 'stretch',
              borderRadius: '7px',
              border: '1px solid var(--color12, #1C124D)',
              background: 'var(--color12, #1C124D)',
              color: 'var(--color2, #FBFBFC)',
            }}
            onClick={onClose}
          >
            <Typography
              sx={{
                color: 'var(--color1, #FDFDFD)',
                textAlign: 'center',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '700',
                lineHeight: 'normal',
              }}
            >
              Go Back
            </Typography>
          </Button>
          <Button
            sx={{
              display: 'flex',
              height: '36px',
              padding: '0px 13px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '13px',
              alignSelf: 'stretch',
              borderRadius: '7px',
              border: '2px solid var(--color12, #1C124D)',
            }}
            onClick={handleCancelOrder}
            disabled={isDeleting}
          >
            <Typography
              sx={{
                color: 'var(--color12, #1C124D)',
                textAlign: 'center',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '700',
                lineHeight: 'normal',
              }}
            >
              {isDeleting ? 'Cancelling...' : 'Cancel This Order'}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
